export default __webpack_public_path__ + "static/media/Chetan Bhanot.50db5b7c.png";